import AddressGetLatLngOnSelected from "../../../pages/address/functions/Address.GetLatLngOnSlected";
import { STATE_CONSTANTS_ADDRESS } from "../../../utils/useConstantState";

const NavbarClickLocationSearch = async ({
  isPageAddress,
  tab,
  setTab,
  setSelectedLocation,
  setValue,
  locationValue,
  navigate,
  refValue,
  setTempLocation,
}) => {
  if (tab && tab !== STATE_CONSTANTS_ADDRESS.FOUND && setTab) {
    setTab(STATE_CONSTANTS_ADDRESS.FOUND);
  }

  // console.log("locationValue", locationValue);

  // console.log("refValue", { refValue, locationValue, get: refValue?.value });

  if (locationValue) {
    await AddressGetLatLngOnSelected(
      setSelectedLocation,
      {
        ...locationValue,
        name_google: refValue?.value,
      },
      setTempLocation
    );
  }

  // setValue("");

  // if (!isPageAddress) {
  //   navigate("/Address");
  // }
};

export default NavbarClickLocationSearch;
